// removed by extract-text-webpack-plugin
module.exports = {"addPartnerCompanySucessDialog":"_3I1kUOJ3L5B7eze5AHo1za"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/organisms/add-partner-company-success-dialog.scss
// module id = 878
// module chunks = 0